import React from 'react';
import PropTypes from 'prop-types';
import { validSideOrders } from '../helpers/mealExchangeHelpers';
import {
  mealExchangeChangeAmountSideOrder,
  mealExchangeUpdateDayPriceAdjustment,
} from '../../../../redux/actions/orderFormActions';
import { useDispatch } from 'react-redux';
import { getMinMaxSelectedMeals } from '../../../../redux/selectors/orderFormSelector';
import SideOrders from '../../../common/SideOrders';
import { useAppSelector } from '../../../../config/hooks';

const SideOrderCarousel = ({
  activeDay,
  mealsListPerDay,
  sideOrdersPerDay,
}) => {
  const dispatch = useDispatch();
  const { max, min } = useAppSelector(getMinMaxSelectedMeals);

  const valid = (sideOrder, changeType) =>
    dispatch(
      validSideOrders(
        mealsListPerDay,
        sideOrdersPerDay,
        changeType,
        sideOrder,
        min,
        max
      )
    );

  const increase = sideOrder => {
    if (valid(sideOrder, 'increase')) {
      dispatch(mealExchangeChangeAmountSideOrder(sideOrder, 'increase'));
      dispatch(
        mealExchangeUpdateDayPriceAdjustment(
          sideOrder.defaultPrice,
          'sideOrders'
        )
      );
    }
  };

  const onClick = sideOrder => {
    const minQuantity = sideOrder?.minQuantity;
    const defaultPrice = sideOrder?.defaultPrice;

    if (valid(sideOrder, 'add')) {
      dispatch(mealExchangeChangeAmountSideOrder(sideOrder, 'add'));
      minQuantity
        ? dispatch(
            mealExchangeUpdateDayPriceAdjustment(
              defaultPrice * minQuantity,
              'sideOrders'
            )
          )
        : dispatch(
            mealExchangeUpdateDayPriceAdjustment(defaultPrice, 'sideOrders')
          );
    }
  };

  const decrease = sideOrder => {
    if (valid(sideOrder, 'decrease')) {
      dispatch(mealExchangeChangeAmountSideOrder(sideOrder, 'decrease'));
      dispatch(
        mealExchangeUpdateDayPriceAdjustment(
          -sideOrder.defaultPrice,
          'sideOrders'
        )
      );
    }
  };

  const removeCb = sideOrder => {
    const minQuantity = sideOrder?.minQuantity;
    const defaultPrice = sideOrder?.defaultPrice;

    if (valid(sideOrder, 'remove')) {
      dispatch(mealExchangeChangeAmountSideOrder(sideOrder, 'remove'));
      minQuantity
        ? dispatch(
            mealExchangeUpdateDayPriceAdjustment(
              -defaultPrice * minQuantity,
              'sideOrders'
            )
          )
        : dispatch(
            mealExchangeUpdateDayPriceAdjustment(-defaultPrice, 'sideOrders')
          );
    }
  };

  const selectedSideOrdersLength = sideOrdersPerDay.reduce((acc, curr) => {
    if (curr.amount) {
      acc = acc + curr.amount;
    }
    return acc;
  }, 0);

  return (
    <SideOrders
      activeDay={activeDay}
      decrease={sideOrder => {
        decrease(sideOrder);
      }}
      increase={sideOrder => {
        increase(sideOrder);
      }}
      label={selectedSideOrdersLength}
      onClick={sideOrder => {
        onClick(sideOrder);
      }}
      removeCb={sideOrder => {
        removeCb(sideOrder);
      }}
      sideOrders={sideOrdersPerDay}
    />
  );
};

SideOrderCarousel.propTypes = {
  activeDay: PropTypes.string,
  mealsListPerDay: PropTypes.array,
  sideOrdersPerDay: PropTypes.array,
};

export default SideOrderCarousel;
